export function removeUndefinedAndNullPropertiesFromObject<T extends object>(object: T): Partial<T> {
    return Object.entries(object).reduce<Partial<T>>(
        (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
        {}
    );
}
